var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7533 5.56287L19.2615 14L27.7533 22.4371C27.9068 22.1163 27.9999 21.7616 27.9999 21.3828V6.61719C27.9999 6.23837 27.9068 5.88372 27.7533 5.56287Z",
    fill: "#FDB426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5392 4.15625H2.46106C2.08224 4.15625 1.72759 4.24938 1.40674 4.40289L12.2602 15.2016C13.2198 16.1613 14.7804 16.1613 15.7401 15.2016L26.5935 4.40289C26.2726 4.24938 25.918 4.15625 25.5392 4.15625Z",
    fill: "#FDB426"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.246641 5.56287C0.0931328 5.88372 0 6.23837 0 6.61719V21.3828C0 21.7616 0.0931328 22.1163 0.246641 22.4371L8.73846 14L0.246641 5.56287Z",
    fill: "#FDB426"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1017 15.16L16.9 16.3616C15.301 17.9606 12.6992 17.9606 11.1002 16.3616L9.89856 15.16L1.40674 23.5971C1.72759 23.7506 2.08224 23.8437 2.46106 23.8437H25.5392C25.918 23.8437 26.2726 23.7506 26.5935 23.5971L18.1017 15.16Z",
    fill: "#FDB426"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9466e86f71871a9cc2aeb7e39ea9f3d3.svg";
export { ForwardRef as ReactComponent };